module.exports = __webpack_public_path__ + "static/media/image-3.6f403a7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/Ecommerce/image-3.png
// module id = 442
// module chunks = 0